import * as Yup from 'yup';

/**
 * Merge several yup schemas together
 * @param schemas the schemas to merge
 */
export const merge = (...schemas: Yup.Object): Yup.Object => {
  const [first, ...rest] = schemas;

  const merged = rest.reduce((mergedSchemas, schema) => mergedSchemas.concat(schema), first);

  return merged;
};

/**
 * French phone number regexp
 */
export const phoneRegExp = /^((?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}|)$/;

/**
 * Url characters regexp
 */
export const safeUrlCharRegExp = /^[A-Za-zÀÂÄÇÉÈÊËÎÏÔÖÙÛÜàâäçéèêëîïôöùûüÿ'0-9-]*$/;

/**
 * Email schema validation
 */
export const userEmailSchema = Yup.object({
  email: Yup.string('Entrez votre e-mail.')
    .email("L'e-mail saisi n'a pas un format valide.")
    .required("L'e-mail est manquant."),
});

/**
 * User Name schema validation
 */
export const userNameSchema = Yup.object({
  firstName: Yup.string('Entrez votre prénom.').required('Le prénom est manquant.'),
  lastName: Yup.string('Entrez votre nom.').required('Le nom est manquant.'),
});

/**
 * New Password schema validation
 */
export const userNewPasswordSchema = Yup.object({
  firstPassword: Yup.string('Entrez un mot de passe.')
    .required('Le mot de passe est manquant.')
    .min(8, 'Le mot de passe doit contenir au moins 8 caractères.')
    .max(100, 'Le mot de passe ne peut pas contenir plus de 100 caractères.')
    .matches(/^(?=.*[a-z])/, 'Le mot de passe doit contenir une minuscule.')
    .matches(/^(?=.*[0-9])/, 'Le mot de passe doit contenir un chiffre.'),
});

/**
 * New Password schema validation
 */
export const userNewPasswordWithConfirmationSchema = merge(
  userNewPasswordSchema,
  Yup.object({
    secondPassword: Yup.string('Confirmez le mot de passe.')
      .required("Le mot de passe n'a pas été confirmé.")
      .oneOf([Yup.ref('firstPassword'), null], 'Les mots de passe doivent correspondre.'),
  })
);

/**
 * Password schema validation
 */
export const userPasswordSchema = Yup.object({
  password: Yup.string('Entrez votre mot de passe.').required('Le mot de passe est manquant.'),
});
